import dayjs from 'dayjs';
import getOffsetTime from '../../../../../utils/getOffsetTime.js';


const addTour = (itemDetails, dayTypesAllowTour) => {
  const { dayTypeId, tourStartTime, tourEndTime, mealStartTime, mealEndTime } = itemDetails;
  const { notification, comment, comment15  } = itemDetails.tourParams;
  const tempDayTypeId = `${Math.floor(Math.random() * (19999999 - 10000000 + 1)) + 10000000}-optimistic`;
  const tempTourId = `${Math.floor(Math.random() * (19999999 - 10000000 + 1)) + 10000000}-optimistic`;
  const tempMealId = `${Math.floor(Math.random() * (9999999 - 9000000 + 1)) + 9000000}-optimistic`;

  let startTime = dayjs(tourStartTime);
  let timeZoneOffset = getOffsetTime(tourStartTime);
  startTime = startTime.subtract(timeZoneOffset, 'minute').unix();
  let mealStartTimeUnix = dayjs(mealStartTime).subtract(timeZoneOffset, 'minute').unix();
  let mealEndTimeUnix = dayjs(mealEndTime).subtract(timeZoneOffset , 'minute').unix();
  // create new dayType, tour and meal
  const tour = {
    tourId: tempTourId,
    startTime,
    duration: dayjs(tourEndTime).diff(dayjs(tourStartTime),'hour'),
    notificationComment: notification,
    tourComment: comment,
    myTourComment: comment15,
    tourIndicators: [],
    tourPayTransactions: [],
    meal: mealStartTime ? {
      mealId: tempMealId,
      mealTime: mealStartTimeUnix,
      mealEndTime: mealEndTimeUnix,
      red: false
    } : null,
    assignments: {}
  };
  const dayType = {
    rdtId: tempDayTypeId,
    title: dayTypesAllowTour.find((elem) => elem.id == dayTypeId).name,
    rdtComment: itemDetails.dayTypeParams ? itemDetails.dayTypeParams.comment : " ",
    myDayComment: itemDetails.dayTypeParams ? itemDetails.dayTypeParams.myComment : " ",
    dayOff: null,
    tour
  };
  return dayType;
}

export default addTour;
